import{a as c}from"./chunk-2HA4XQFN.js";var s=c((p,t,o)=>{let m=p[t];p[t]=p[o],p[o]=m},"swap");export{s as a};
